var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"st-list"},_vm._l((_vm.list),function(item,index){return _c('st-list-item',{key:((item.label) + "-" + index),attrs:{"item":item,"skip-border-bottom":_vm.skipBorderBottom,"is-vertical":_vm.isVertical}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }